export enum StudyType {
  TIIM = 'regular',
  CC = 'careercompass',
}
